module.exports = __webpack_public_path__ + "static/media/easypm-in-macbook.5716df15.svg";